import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Animal } from '../../components/animal/ui';
import { Player } from '../../components/players/player';
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const CameraPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Животноводство</title>
            </Helmet>
            <Animal/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default CameraPage
